import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'

const featuresContent =[
    {
        img:'line-round-5b',
        icon:'icon-18b',
        title:'Pulsa dan Paket Data',
        desc:'Kami menyediakan pulsa, paket data, dan voucher dengan harga yang terjangkau.',
        dataAos:'fade-up',
        dataAosDown:'fade-down',
        dataDelay: '',
        dataDelayDown: '100',
    },
    {
        img:'line-round-5b',
        icon:'icon-19b',
        title:'Top Up Digital',
        desc:'Melayani mulai dari pembayaran PLN, PDAM dan lainnya dijamin lengkap dan cepat .',
        dataAos:'fade-up',
        dataAosDown:'fade-down',
        dataDelay: '100',
        dataDelayDown: '100',
    },
    {
        img:'line-round-5b',
        icon:'icon-20b',
        title:'Aksesoris dan Peralatan Rumah Tangga',
        desc:'Penjualan aksesoris hp dan keperluan rumah tangga lainnya yang di pastikan lengkap ',
        dataAos:'fade-up',
        dataAosDown:'fade-down',
        dataDelay: '150',
        dataDelayDown: '100',
    },
    
]

const FeatureFour = () => {
    return (
        <Fragment>
            <div className="row gx-4 gx-xxl-5">
                {featuresContent.map((val,i)=>(
                    <div key={i} className="col-lg-4 col-md-6" data-aos={val.dataAos} data-aos-delay={val.dataDelay}>
                    <div className="feature-style-four mb-45">
                        <img
                            className="shape-over"
                            data-aos={val.dataAosDown}
                            data-aos-delay={val.dataDelayDown}
                            src={`assets/img/shape/${val.img}.svg`}
                            alt="shape"/>
                        <img src={`assets/img/icon/${val.icon}.svg`} alt="icon"/>
                        <h2>
                            <Link className="sect-title-two" to="/services-details">{val.title}</Link>
                        </h2>
                        <p>{val.desc}</p>
                    </div>
                </div>
                ))}
            </div>
        </Fragment>
    )
}

export default FeatureFour